import React from 'react';
import { observer } from 'mobx-react';
import { IChildConnectionDTO, IConnectionAttendeeDTO, IConnectionDetailsDTO, IConnectionGroupDTO, IParentConnectionDTO } from '../../../../../../api/connections.dao';
import { CONNECTION_DETAILS_POPOVER_TRACKING_EVENTS } from '../../../../../../tracking-service/tracking-values';
import { ConnectionEntity } from '../../../../../../modules/connections/abstract-connection.entity';
import { PresenterOrHostMeetingAttendee } from '../../../../../../modules/connections/meeting/presenter-or-host-attendee-meeting.connection.entity';
import { AttendeeUniqueConnectionGroupIndicator } from './attendee-unique-connection-group-indicator/attendee-unique-connection-group-indicator';
import { AttendeeUniqueConnectionIndicator } from './attendee-unique-connection-indicator/attendee-unique-connection-indicator';
import { ChildConnectionsViewModel } from '../../_meeting-connections-form/child-connections/child-connections.viewmodel';

export type AttendeeUniqueConnectionIndicatorWrapperProps = {
    parentConnection: IParentConnectionDTO | undefined;
    childConnection: IChildConnectionDTO | undefined;
    handleTrackChildCopyBtn?: (event: CONNECTION_DETAILS_POPOVER_TRACKING_EVENTS, type: string) => void;
    withLeftMargin: boolean;
    entity: ConnectionEntity<IConnectionAttendeeDTO> | PresenterOrHostMeetingAttendee;
    assignedConnectionGroup: IConnectionGroupDTO;
    meetingConnections: IConnectionDetailsDTO[];
    parentConnections: IParentConnectionDTO[];
    childConnectionsVM: ChildConnectionsViewModel;
    setIsOpenConnectionsInGroup: React.Dispatch<React.SetStateAction<boolean>>;
    isOpenConnectionsInGroup: boolean;
};

export const AttendeeUniqueConnectionIndicatorWrapper: React.FC<AttendeeUniqueConnectionIndicatorWrapperProps> = observer((props): JSX.Element => {
    const {
        parentConnection,
        childConnection,
        withLeftMargin,
        handleTrackChildCopyBtn,
        assignedConnectionGroup,
        meetingConnections,
        parentConnections,
        entity,
        childConnectionsVM,
        setIsOpenConnectionsInGroup,
        isOpenConnectionsInGroup,
    } = props;

    return assignedConnectionGroup
        ? <AttendeeUniqueConnectionGroupIndicator
            assignedConnectionGroup={assignedConnectionGroup}
            meetingConnections={meetingConnections}
            parentConnections={parentConnections}
            entity={entity}
            withLeftMargin={withLeftMargin}
            setIsOpenConnectionsInGroup={setIsOpenConnectionsInGroup}
            isOpenConnectionsInGroup={isOpenConnectionsInGroup}
        />
        : <AttendeeUniqueConnectionIndicator
            parentConnection={parentConnection}
            childConnection={childConnection}
            handleTrackChildCopyBtn={handleTrackChildCopyBtn}
            withLeftMargin={withLeftMargin}
            childConnectionsVM={childConnectionsVM}
        />;
});
